import ViewPdf from "./ViewPdf";

export { ViewPdf as default };
